import React, { ReactNode } from 'react';
import { Button, Spinner, Grid } from 'ui-toolkit';
import { Form, Formik } from 'formik';
import * as yup from 'yup';

export interface ISingleFieldEditFormProps<T> {
  initialValue: T;
  validationSchema: any;
  onUpdate: (value?: T) => Promise<void>;
  onClose: () => void;
  children: ReactNode;
}

export const SingleFieldInlineEditForm = <T extends any>({
  initialValue,
  validationSchema,
  onUpdate,
  onClose,
  children,
}: ISingleFieldEditFormProps<T>) => {
  return (
    <Formik
      initialValues={{ value: initialValue }}
      validationSchema={yup.object({ value: validationSchema })}
      onSubmit={async (values) => {
        await onUpdate(values.value);
        onClose();
      }}
    >
      {({ isSubmitting }) => (
        <Form>
          <Grid templateColumns={`3fr 1fr`} alignItems={`center`}>
            {!isSubmitting && children}
            {!isSubmitting && (
              <Button intent="ghost" isInline type="submit">
                Update
              </Button>
            )}
            {isSubmitting && <Spinner />}
          </Grid>
        </Form>
      )}
    </Formik>
  );
};
